<template>
  <v-dialog
    v-model="dialog"
    transition="dialog-bottom-transition"
    fullscreen
    persistent
    content-class="main-dialog"
  >
    <br>
    <v-container
      class="small qr-scanner-style"
      fluid
    >
      <div>
        <v-btn
          fab
          color="transparent"
          elevation="0"
          @click="close()"
        >
          <v-icon color="#FFFFF">
            mdi-close-thick
          </v-icon>
        </v-btn>
        <div class="pa-4 text-center">
          <p class="white--text font-weight-bold">
            Scan QR Code
          </p>
          <div
            id="reader"
            class="scanner-div mt-5"
          />
          <p class="white--text font-weight-bold mt-5">
            Scan your site's qr code for continuing the process
          </p>
        </div>
      </div>
    </v-container>
    <centre-spinner
      :loading="loading"
    />
  </v-dialog>
</template>
<script>
import spinner from 'src/views/components/SpinnerCentre';
import { Html5Qrcode } from 'html5-qrcode';

  export default {
    name: 'QrCodeScanner',
    components: {
      'centre-spinner': spinner,
    },
    data () {
      return {
        dialog: true,
        loading: false,
        html5QrCodeScanner: null,
      };
    },
    computed: {
      activeCheckInDetails () {
        return this.$store.getters['swiftuser/getActiveCheckInDetails'];
      },
      isActiveCheckInDetailsFetched () {
        if (Object.keys(this.activeCheckInDetails).length > 0) {
          return true;
        }
        return false;
      },
    },
    watch: {
      dialog: function (newval, oldval) {
        if (newval === false) {
          this.$emit('closed');
        }
      },
    },
    mounted () {
      this.loading = true;
      setTimeout(() => {
        this.scanQrCode();
      }, 2000);
    },
    methods: {
      scanQrCode () {
        this.loading = false;
        this.html5QrCodeScanner = new Html5Qrcode('reader');
        const config = { fps: 60, qrbox: { width: 250, height: 250 } };
        this.html5QrCodeScanner.start({ facingMode: 'environment' }, config, this.qrCodeSuccessCallback);
      },
      qrCodeSuccessCallback (qrCodeUrl) {
        this.loading = true;
        this.html5QrCodeScanner.stop().then(() => {
          this.passScannedUrl(qrCodeUrl);
        }).catch(() => {
          this.loading = false;
          this.dialog = false;
        });
      },
      passScannedUrl (qrCodeUrl) {
        const siteId = qrCodeUrl.split('/').pop();
        this.$store.dispatch('swiftuser/onQrCodeScan', siteId);
        localStorage.setItem('siteId', siteId);
        localStorage.setItem('scannedTime', new Date().getTime());
        setTimeout(() => {
          this.loading = false;
          this.$emit('qr-code-scanned', siteId);
          this.dialog = false;
        }, 1000);
      },
      close () {
        this.loading = true;
        setTimeout(() => {
          this.html5QrCodeScanner.stop().then(() => {
            this.loading = false;
            this.dialog = false;
          }).catch(() => {
            this.loading = false;
            this.dialog = false;
          });
        }, 2000);
      },
    },
  };
</script>
<style>
.main-dialog {
  background-color: #373737 !important;
}
</style>
<style scoped>
.scanner-div {
  color: #FF3700;
  font-size: 18px;
  font-family: 'Times New Roman', Times, serif;
  font-weight: bold;
  margin-top: 50px !important;
  margin-bottom: 50px !important;
}
.title-style {
  color: #37474F;
  margin-left: 20px;
}
.icon-style {
  color: #37474F;
  font-size: 45px;
}
.subtitle-style {
  color: #546E7A;
  font-family: 'Times New Roman', Times, serif;
  font-size: 20px;
  margin-top: 10px;
  margin-bottom: 10px;
  text-align: center;
}
.v-card--reveal {
  align-items: center;
  bottom: 0;
  justify-content: center;
  position: absolute;
  width: 100%;
}
</style>
